var render, staticRenderFns
import script from "./ChartExample.vue?vue&type=script&lang=js&"
export * from "./ChartExample.vue?vue&type=script&lang=js&"
import style0 from "./ChartExample.vue?vue&type=style&index=0&id=22fcbdda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fcbdda",
  null
  
)

export default component.exports